import React from "react";


function Administration() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider-1.jpg)',backgroundSize:'cover',backgroundPosition:'top'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        <h1>Administrative Members</h1>
        {/* <div className="row">
            <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/trustee.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">H.H. Sree Padmanabhadasa Moolam Thirunal Rama Varma</p>
                            <p className="designation">Trustee</p>
                        </div>
                    </div>                    
                </div>
           </div>            
        </div> */}

        {/* <div className="row">
            <div className="col-md-12">
                <h3 style={{marginBottom:'30px',fontSize:'20pt'}}>Administrative Committee</h3>
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/anil.jpg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Sri. Anilkumar K P</p>
                            <p className="designation">Chairman, Additional District & Sessions Judge - I, Trivandrum</p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/Adithya.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Adithya Varma</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/jayan.jpg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Karamana Jayan</p>
                            <p className="designation"></p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/velappan.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Adv. A. Velappan Nair</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/govindan.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Govindan Namboodiripad</p>
                            <p className="designation"></p>
                        </div>
                    </div>              
                </div>
           </div>            
        </div> */}


        {/* <div className="row">
            <div className="col-md-12">
                <h3 style={{marginBottom:'30px',fontSize:'20pt'}}>Advisory Committee</h3>
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/justice.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Justice T R Ramachandran Nair (Rtd.)</p>
                            <p className="designation">Chairman</p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/bala.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">T. Balakrishnan IAS (Rtd.)</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/suresh.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">S Suresh</p>
                            <p className="designation">FCA</p>
                        </div>
                    </div>    
                </div>
           </div>            
        </div> */}


      </div>
    </div>
  );
}

export default Administration;